/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesDraftTeamStatusSchema = z.enum([
  "WaitingForDraft",
  "Drafting",
  "DraftComplete",
  "TeamReady",
]);
